var cov_1gzqpeuhu = function () {
  var path = "/Users/spana/SHEIN/shineout/src/CardGroup/CardGroup.tsx",
      hash = "c255149d05fb480ec2e2a0a73558f4a559113e89",
      Function = function () {}.constructor,
      global = new Function('return this')(),
      gcv = "__coverage__",
      coverageData = {
    path: "/Users/spana/SHEIN/shineout/src/CardGroup/CardGroup.tsx",
    statementMap: {
      "0": {
        start: {
          line: 19,
          column: 4
        },
        end: {
          line: 19,
          column: 16
        }
      },
      "1": {
        start: {
          line: 20,
          column: 4
        },
        end: {
          line: 22,
          column: 5
        }
      },
      "2": {
        start: {
          line: 23,
          column: 4
        },
        end: {
          line: 23,
          column: 52
        }
      },
      "3": {
        start: {
          line: 28,
          column: 28
        },
        end: {
          line: 28,
          column: 38
        }
      },
      "4": {
        start: {
          line: 29,
          column: 4
        },
        end: {
          line: 29,
          column: 43
        }
      },
      "5": {
        start: {
          line: 29,
          column: 30
        },
        end: {
          line: 29,
          column: 43
        }
      },
      "6": {
        start: {
          line: 30,
          column: 4
        },
        end: {
          line: 30,
          column: 14
        }
      },
      "7": {
        start: {
          line: 34,
          column: 25
        },
        end: {
          line: 34,
          column: 35
        }
      },
      "8": {
        start: {
          line: 35,
          column: 4
        },
        end: {
          line: 35,
          column: 32
        }
      },
      "9": {
        start: {
          line: 35,
          column: 26
        },
        end: {
          line: 35,
          column: 32
        }
      },
      "10": {
        start: {
          line: 36,
          column: 4
        },
        end: {
          line: 38,
          column: 6
        }
      },
      "11": {
        start: {
          line: 42,
          column: 55
        },
        end: {
          line: 42,
          column: 65
        }
      },
      "12": {
        start: {
          line: 43,
          column: 25
        },
        end: {
          line: 43,
          column: 35
        }
      },
      "13": {
        start: {
          line: 44,
          column: 4
        },
        end: {
          line: 44,
          column: 34
        }
      },
      "14": {
        start: {
          line: 44,
          column: 19
        },
        end: {
          line: 44,
          column: 34
        }
      },
      "15": {
        start: {
          line: 45,
          column: 16
        },
        end: {
          line: 45,
          column: 29
        }
      },
      "16": {
        start: {
          line: 46,
          column: 20
        },
        end: {
          line: 48,
          column: 5
        }
      },
      "17": {
        start: {
          line: 49,
          column: 22
        },
        end: {
          line: 55,
          column: 5
        }
      },
      "18": {
        start: {
          line: 56,
          column: 4
        },
        end: {
          line: 64,
          column: 5
        }
      },
      "19": {
        start: {
          line: 68,
          column: 41
        },
        end: {
          line: 68,
          column: 51
        }
      },
      "20": {
        start: {
          line: 69,
          column: 16
        },
        end: {
          line: 69,
          column: 57
        }
      },
      "21": {
        start: {
          line: 70,
          column: 23
        },
        end: {
          line: 73,
          column: 5
        }
      },
      "22": {
        start: {
          line: 74,
          column: 4
        },
        end: {
          line: 78,
          column: 5
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 18,
            column: 2
          },
          end: {
            line: 18,
            column: 3
          }
        },
        loc: {
          start: {
            line: 18,
            column: 37
          },
          end: {
            line: 24,
            column: 3
          }
        },
        line: 18
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 26,
            column: 2
          },
          end: {
            line: 26,
            column: 3
          }
        },
        loc: {
          start: {
            line: 26,
            column: 11
          },
          end: {
            line: 31,
            column: 3
          }
        },
        line: 26
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 33,
            column: 2
          },
          end: {
            line: 33,
            column: 3
          }
        },
        loc: {
          start: {
            line: 33,
            column: 36
          },
          end: {
            line: 39,
            column: 3
          }
        },
        line: 33
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 41,
            column: 2
          },
          end: {
            line: 41,
            column: 3
          }
        },
        loc: {
          start: {
            line: 41,
            column: 15
          },
          end: {
            line: 65,
            column: 3
          }
        },
        line: 41
      },
      "4": {
        name: "(anonymous_4)",
        decl: {
          start: {
            line: 67,
            column: 2
          },
          end: {
            line: 67,
            column: 3
          }
        },
        loc: {
          start: {
            line: 67,
            column: 11
          },
          end: {
            line: 79,
            column: 3
          }
        },
        line: 67
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 29,
            column: 4
          },
          end: {
            line: 29,
            column: 43
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 29,
            column: 4
          },
          end: {
            line: 29,
            column: 43
          }
        }, {
          start: {
            line: 29,
            column: 4
          },
          end: {
            line: 29,
            column: 43
          }
        }],
        line: 29
      },
      "1": {
        loc: {
          start: {
            line: 35,
            column: 4
          },
          end: {
            line: 35,
            column: 32
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 35,
            column: 4
          },
          end: {
            line: 35,
            column: 32
          }
        }, {
          start: {
            line: 35,
            column: 4
          },
          end: {
            line: 35,
            column: 32
          }
        }],
        line: 35
      },
      "2": {
        loc: {
          start: {
            line: 35,
            column: 8
          },
          end: {
            line: 35,
            column: 24
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 35,
            column: 8
          },
          end: {
            line: 35,
            column: 16
          }
        }, {
          start: {
            line: 35,
            column: 20
          },
          end: {
            line: 35,
            column: 24
          }
        }],
        line: 35
      },
      "3": {
        loc: {
          start: {
            line: 44,
            column: 4
          },
          end: {
            line: 44,
            column: 34
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 44,
            column: 4
          },
          end: {
            line: 44,
            column: 34
          }
        }, {
          start: {
            line: 44,
            column: 4
          },
          end: {
            line: 44,
            column: 34
          }
        }],
        line: 44
      },
      "4": {
        loc: {
          start: {
            line: 54,
            column: 8
          },
          end: {
            line: 54,
            column: 110
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 54,
            column: 34
          },
          end: {
            line: 54,
            column: 82
          }
        }, {
          start: {
            line: 54,
            column: 85
          },
          end: {
            line: 54,
            column: 110
          }
        }],
        line: 54
      },
      "5": {
        loc: {
          start: {
            line: 60,
            column: 13
          },
          end: {
            line: 60,
            column: 33
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 60,
            column: 13
          },
          end: {
            line: 60,
            column: 21
          }
        }, {
          start: {
            line: 60,
            column: 25
          },
          end: {
            line: 60,
            column: 33
          }
        }],
        line: 60
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0,
      "21": 0,
      "22": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0
    },
    b: {
      "0": [0, 0],
      "1": [0, 0],
      "2": [0, 0],
      "3": [0, 0],
      "4": [0, 0],
      "5": [0, 0]
    },
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184"
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

import _objectSpread2 from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread";
import _objectWithoutProperties from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import _classCallCheck from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
var _jsxFileName = "/Users/spana/SHEIN/shineout/src/CardGroup/CardGroup.tsx";

function _createSuper2(Derived) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }

  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (isNativeReflectConstruct()) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

import React from 'react';
import classname from 'classnames';
import { cardGroupClass } from './styles';
import { PureComponent } from '../component';
import { Provider } from './context';

var CardGroup =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(CardGroup, _PureComponent);

  var _super = _createSuper2(CardGroup);

  function CardGroup(props) {
    var _this;

    _classCallCheck(this, CardGroup);

    cov_1gzqpeuhu.f[0]++;
    cov_1gzqpeuhu.s[0]++;
    _this = _super.call(this, props);
    cov_1gzqpeuhu.s[1]++;
    _this.state = {
      scroller: undefined
    };
    cov_1gzqpeuhu.s[2]++;
    _this.bindScroller = _this.bindScroller.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(CardGroup, [{
    key: "getGap",
    value: function getGap() {
      cov_1gzqpeuhu.f[1]++;

      // @ts-ignore gap 属性以被重命名了
      var _ref = (cov_1gzqpeuhu.s[3]++, this.props),
          gap = _ref.gap,
          gutter = _ref.gutter;

      cov_1gzqpeuhu.s[4]++;

      if (gutter !== undefined) {
        cov_1gzqpeuhu.b[0][0]++;
        cov_1gzqpeuhu.s[5]++;
        return gutter;
      } else {
        cov_1gzqpeuhu.b[0][1]++;
      }

      cov_1gzqpeuhu.s[6]++;
      return gap;
    }
  }, {
    key: "bindScroller",
    value: function bindScroller(ref) {
      cov_1gzqpeuhu.f[2]++;

      var _ref2 = (cov_1gzqpeuhu.s[7]++, this.state),
          scroller = _ref2.scroller;

      cov_1gzqpeuhu.s[8]++;

      if ((cov_1gzqpeuhu.b[2][0]++, scroller) || (cov_1gzqpeuhu.b[2][1]++, !ref)) {
        cov_1gzqpeuhu.b[1][0]++;
        cov_1gzqpeuhu.s[9]++;
        return;
      } else {
        cov_1gzqpeuhu.b[1][1]++;
      }

      cov_1gzqpeuhu.s[10]++;
      this.setState({
        scroller: ref
      });
    }
  }, {
    key: "renderBody",
    value: function renderBody() {
      cov_1gzqpeuhu.f[3]++;

      var _ref3 = (cov_1gzqpeuhu.s[11]++, this.props),
          cardWidth = _ref3.cardWidth,
          columns = _ref3.columns,
          children = _ref3.children,
          other = _objectWithoutProperties(_ref3, ["cardWidth", "columns", "children"]);

      var _ref4 = (cov_1gzqpeuhu.s[12]++, this.state),
          scroller = _ref4.scroller;

      cov_1gzqpeuhu.s[13]++;

      if (!children) {
        cov_1gzqpeuhu.b[3][0]++;
        cov_1gzqpeuhu.s[14]++;
        return children;
      } else {
        cov_1gzqpeuhu.b[3][1]++;
      }

      var gap = (cov_1gzqpeuhu.s[15]++, this.getGap());
      var context = (cov_1gzqpeuhu.s[16]++, {
        container: scroller
      });
      var gridStyle = (cov_1gzqpeuhu.s[17]++, _objectSpread2(_objectSpread2({
        gridRowGap: gap,
        gridColumnGap: gap
      }, other.gridStyle), {}, {
        gridTemplateColumns: cardWidth !== undefined ? (cov_1gzqpeuhu.b[4][0]++, "repeat(auto-fill, minmax(".concat(cardWidth, "px, 1fr))")) : (cov_1gzqpeuhu.b[4][1]++, "repeat(".concat(columns, ", 1fr)"))
      }));
      cov_1gzqpeuhu.s[18]++;
      return (
        /*#__PURE__*/
        React.createElement(Provider, {
          value: context,
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 57,
            columnNumber: 7
          }
        },
        /*#__PURE__*/
        React.createElement("div", {
          className: cardGroupClass('scroller'),
          ref: this.bindScroller,
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 58,
            columnNumber: 9
          }
        },
        /*#__PURE__*/
        React.createElement("div", {
          style: gridStyle,
          className: cardGroupClass('grid'),
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 59,
            columnNumber: 11
          }
        }, (cov_1gzqpeuhu.b[5][0]++, scroller) && (cov_1gzqpeuhu.b[5][1]++, children))))
      );
    }
  }, {
    key: "render",
    value: function render() {
      cov_1gzqpeuhu.f[4]++;

      var _ref5 = (cov_1gzqpeuhu.s[19]++, this.props),
          height = _ref5.height,
          style = _ref5.style,
          className = _ref5.className;

      var cls = (cov_1gzqpeuhu.s[20]++, classname(cardGroupClass('_'), className));
      var groupStyle = (cov_1gzqpeuhu.s[21]++, _objectSpread2({
        height: height
      }, style));
      cov_1gzqpeuhu.s[22]++;
      return (
        /*#__PURE__*/
        React.createElement("div", {
          style: groupStyle,
          className: cls,
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 75,
            columnNumber: 7
          }
        }, this.renderBody())
      );
    }
  }]);

  return CardGroup;
}(PureComponent);

CardGroup.defaultProps = {
  columns: 3,
  gap: 16
};
export default CardGroup;